import { getClientEnv, isEu } from "common/util"

export const getVTextUrl = async () => {
  let url = "https://copywriting-web-us.eufy.com"
  const isPr = getClientEnv('REACT_APP_DEPLOY_ENV') === 'pr'

  if (await isEu()) {
    url = "https://copywriting-web-eu.eufy.com"
  }
  if (!isPr) {
    url = "https://copywriting-web-us-qa.eufylife.com"
  }
  return url
}

/**
 * 获取火山文案
 * @param data 包含language 当前语言， projectId 火山项目id, namespace 文案空间 filterPrefixes 过滤前缀
 */
export const getVText = async (
  language: string,
  projectId: string,
  namespace: string,
  filterPrefixes?: string
) => {
  const queryParams = new URLSearchParams();
  // 添加必要的参数
  queryParams.append('language', language);
  queryParams.append('projectId', projectId);
  queryParams.append('namespace', namespace);
   // 如果filterPrefixes存在，则添加该参数
   if (filterPrefixes) {
    queryParams.append('filterPrefixes', filterPrefixes);
  }

  const responseUrl = `${await getVTextUrl()}/api/getVText?${queryParams}`

  try {
    const response = await fetch(responseUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    return Promise.resolve(data?.data)
  } catch (err) {
    console.error(err)
    return Promise.resolve({})
  }
}
